export default {
  effects: {
    captions: {
      blur: 'Размыццё',
      crop: 'Абрэзка',
      enhance: 'Паляпшэнне',
      flip: 'Адлюстраваць па вертыкалі',
      grayscale: 'Адценні шэрага',
      invert: 'Інвертаваць',
      mirror: 'Адлюстраваць па гарызанталі',
      rotate: 'Павярнуць',
      sharp: 'Выразнасць',
    },
    apply: 'Ужыць',
  },
}
